// extracted by mini-css-extract-plugin
module.exports =  {"list":"e3afc254ff--list--v4_j2","item":"e3afc254ff--item--q2TF_"};